import api from 'src/utils/api';
import { E_API_SERVICEID } from 'src/utils/enum';

/**
 * @name 외부진입 로깅
 * @param hfrom from
 * @param rst1...rst9 그 외 로깅정보
 * */
export const apiSetLogging = async params => {
  const response = await api.post(
    '/fo/logging/outurl',
    { hfrom: 'APP', ...params },
    {
      headers: { 'x-ssp-gateway-service-id': E_API_SERVICEID.ASSISTANT },
    },
  );

  const data = await response.data;

  return data;
};
